import React, { lazy, useEffect, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { loadCategoryTranslations } from "./utils/CategoryTranslator";

import FallbackSpinnerLoader from "./components/FallbackSpinnerLoader";
import Layout from "./pages/Layout";
/* import Signin from './pages/authentication/Signin';
import Signup from './pages/authentication/Signup';
import ResetPassword from './pages/authentication/ResetPassword';
 import Inbox from './pages/Inbox';
import Customers from './pages/Customers';
import AddCustomers from './pages/AddCustomers';
import Catalog from './pages/Catalog';
import Lucci from './pages/Lucci';
import LucciAIChat from './pages/LucciAIChat';
import Channel from './pages/Channel';
import User from './pages/User';
import Schedule from './pages/Schedule';
import Settings from './pages/Settings';
import Business from './pages/Business';
import BusinessDetails from './partials/business/BusinessDetails';
import UpdateBusiness from './partials/business/UpdateBusiness';
import NotFound from './components/NotFound'; */

// Lazy load
const Signin = lazy(() => import("./pages/authentication/Signin"));
const Signup = lazy(() => import("./pages/authentication/Signup"));
const ResetPassword = lazy(
  () => import("./pages/authentication/ResetPassword"),
);
const Inbox = lazy(() => import("./pages/Inbox"));
const MetaOAuthCallback = lazy(() => import("./pages/MetaOAuthCallback"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Customers = lazy(() => import("./pages/Customers"));
const CustomerPage = lazy(() => import("./pages/CustomerPage"));
const AddCustomers = lazy(() => import("./pages/AddCustomers"));
const Catalog = lazy(() => import("./pages/Catalog"));
const Lucci = lazy(() => import("./pages/Lucci"));
const LucciAIChat = lazy(() => import("./pages/LucciAIChat"));
const Channel = lazy(() => import("./pages/Channel"));
const Upload = lazy(() => import("./pages/Upload"));
const User = lazy(() => import("./pages/User"));
const Schedule = lazy(() => import("./pages/Schedule"));
const Settings = lazy(() => import("./pages/Settings"));
const Reports = lazy(() => import("./pages/Reports"));
const Business = lazy(() => import("./pages/Business"));
const Payments = lazy(() => import("./pages/Payments"));
const Insurance = lazy(() => import("./pages/Insurance"));
const IoTTrackers = lazy(() => import("./pages/IoTTrackers"));
const Campaigns = lazy(() => import("./pages/Campaigns"));
const NewPayment = lazy(() => import("./pages/NewPayment"));
const NewRent = lazy(() => import("./pages/NewRent"));
const ImportClients = lazy(() => import("./pages/ImportClients"));
const BusinessDetails = lazy(
  () => import("./partials/business/BusinessDetails"),
);
const UpdateBusiness = lazy(() => import("./partials/business/UpdateBusiness"));
const NotFound = lazy(() => import("./components/NotFound"));

import ProtectedRoute from "./router/ProtectedRoute";

function App() {
  useEffect(() => {
    loadCategoryTranslations();
  }, []);

  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <>
            <div></div>
            <FallbackSpinnerLoader />
          </>
        }
      >
        <Routes>
          <Route
            path="/signin"
            element={
              <Suspense>
                <Signin />
              </Suspense>
            }
          />
          <Route
            path="/signup"
            element={
              <Suspense>
                <Signup />
              </Suspense>
            }
          />
          <Route
            path="/reset-password"
            element={
              <Suspense>
                <ResetPassword />
              </Suspense>
            }
          />
          {/* Meta OAuth popup landing page. Public and outside the layout:
              it only forwards the code to the tab that opened it. */}
          <Route
            path="/oauth/meta/callback"
            element={
              <Suspense>
                <MetaOAuthCallback />
              </Suspense>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route
              path="dashboard"
              element={
                <Suspense
                  fallback={
                    <>
                      <div></div>
                      <FallbackSpinnerLoader />
                    </>
                  }
                >
                  <Dashboard />
                </Suspense>
              }
            />
            <Route
              path="inbox?/:customer_id_param"
              element={
                <Suspense
                  fallback={
                    <>
                      <div></div>
                      <FallbackSpinnerLoader />
                    </>
                  }
                >
                  <Inbox />
                </Suspense>
              }
            />
            <Route
              path="customers/:userId"
              element={
                <Suspense
                  fallback={
                    <>
                      <div></div>
                      <FallbackSpinnerLoader />
                    </>
                  }
                >
                  <CustomerPage />
                </Suspense>
              }
            />
            <Route
              path="customers"
              element={
                <Suspense
                  fallback={
                    <>
                      <div></div>
                      <FallbackSpinnerLoader />
                    </>
                  }
                >
                  <Customers />
                </Suspense>
              }
            />
            <Route
              path="upload"
              element={
                <Suspense
                  fallback={
                    <>
                      <div></div>
                      <FallbackSpinnerLoader />
                    </>
                  }
                >
                  <Upload />
                </Suspense>
              }
            />
            <Route
              path="customers/add"
              element={
                <Suspense
                  fallback={
                    <>
                      <div></div>
                      <FallbackSpinnerLoader />
                    </>
                  }
                >
                  <AddCustomers />
                </Suspense>
              }
            />
            <Route
              path="catalog"
              element={
                <Suspense
                  fallback={
                    <>
                      <div></div>
                      <FallbackSpinnerLoader />
                    </>
                  }
                >
                  <Catalog />
                </Suspense>
              }
            />
            <Route
              path="lucci"
              element={
                <Suspense
                  fallback={
                    <>
                      <div></div>
                      <FallbackSpinnerLoader />
                    </>
                  }
                >
                  <Lucci />
                </Suspense>
              }
            />
            <Route
              path="luccichat"
              element={
                <Suspense
                  fallback={
                    <>
                      <div></div>
                      <FallbackSpinnerLoader />
                    </>
                  }
                >
                  <LucciAIChat />
                </Suspense>
              }
            />
            <Route
              path="channel"
              element={
                <Suspense
                  fallback={
                    <>
                      <div></div>
                      <FallbackSpinnerLoader />
                    </>
                  }
                >
                  <Channel />
                </Suspense>
              }
            />
            <Route
              path="user"
              element={
                <Suspense
                  fallback={
                    <>
                      <div></div>
                      <FallbackSpinnerLoader />
                    </>
                  }
                >
                  <User />
                </Suspense>
              }
            />
            <Route
              path="business"
              element={
                <Suspense
                  fallback={
                    <>
                      <div></div>
                      <FallbackSpinnerLoader />
                    </>
                  }
                >
                  <Business />
                </Suspense>
              }
            />
            <Route
              path="schedule"
              element={
                <Suspense
                  fallback={
                    <>
                      <div></div>
                      <FallbackSpinnerLoader />
                    </>
                  }
                >
                  <Schedule />
                </Suspense>
              }
            />
            <Route
              path="payments"
              element={
                <Suspense
                  fallback={
                    <>
                      <div></div>
                      <FallbackSpinnerLoader />
                    </>
                  }
                >
                  <Payments />
                </Suspense>
              }
            />
            <Route
              path="payments/import-clients"
              element={
                <Suspense
                  fallback={
                    <>
                      <div></div>
                      <FallbackSpinnerLoader />
                    </>
                  }
                >
                  <ImportClients />
                </Suspense>
              }
            />
            <Route
              path="payments/new-payment"
              element={
                <Suspense
                  fallback={
                    <>
                      <div></div>
                      <FallbackSpinnerLoader />
                    </>
                  }
                >
                  <NewPayment />
                </Suspense>
              }
            />
            <Route
              path="insurance"
              element={
                <Suspense
                  fallback={
                    <>
                      <div></div>
                      <FallbackSpinnerLoader />
                    </>
                  }
                >
                  <Insurance />
                </Suspense>
              }
            />
            <Route
              path="iot-trackers"
              element={
                <Suspense
                  fallback={
                    <>
                      <div></div>
                      <FallbackSpinnerLoader />
                    </>
                  }
                >
                  <IoTTrackers />
                </Suspense>
              }
            />
            <Route
              path="campaigns"
              element={
                <Suspense
                  fallback={
                    <>
                      <div></div>
                      <FallbackSpinnerLoader />
                    </>
                  }
                >
                  <Campaigns />
                </Suspense>
              }
            />
            <Route
              path="payments/new-rent"
              element={
                <Suspense
                  fallback={
                    <>
                      <div></div>
                      <FallbackSpinnerLoader />
                    </>
                  }
                >
                  <NewRent />
                </Suspense>
              }
            />
            <Route
              path="business-details/:businessId"
              element={
                <Suspense
                  fallback={
                    <>
                      <div></div>
                      <FallbackSpinnerLoader />
                    </>
                  }
                >
                  <BusinessDetails />
                </Suspense>
              }
            />
            <Route
              path="update-business/:businessId"
              element={
                <Suspense
                  fallback={
                    <>
                      <div></div>
                      <FallbackSpinnerLoader />
                    </>
                  }
                >
                  <UpdateBusiness />
                </Suspense>
              }
            />
            <Route
              path="reports"
              element={
                <Suspense
                  fallback={
                    <>
                      <div></div>
                      <FallbackSpinnerLoader />
                    </>
                  }
                >
                  <Reports />
                </Suspense>
              }
            />
            <Route
              path="settings"
              element={
                <Suspense
                  fallback={
                    <>
                      <div></div>
                      <FallbackSpinnerLoader />
                    </>
                  }
                >
                  <Settings />
                </Suspense>
              }
            />
          </Route>
          <Route
            path="*"
            element={
              <Suspense
                fallback={
                  <>
                    <div></div>
                    <FallbackSpinnerLoader />
                  </>
                }
              >
                <NotFound />
              </Suspense>
            }
          />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
